module.exports = __webpack_public_path__ + "img/ic-ring-solid-pink.f5be55c9.svg";